import { render, staticRenderFns } from "./ExtractBusinessDetails.vue?vue&type=template&id=07121a30&scoped=true&"
import script from "./ExtractBusinessDetails.vue?vue&type=script&lang=js&"
export * from "./ExtractBusinessDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExtractBusinessDetails.vue?vue&type=style&index=0&id=07121a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07121a30",
  null
  
)

export default component.exports